module.exports = __webpack_public_path__ + "media/images/emblems/Chatel-Saint-Denis-coat_of_arms-748cf57915d37bfa0f13028f2aef1370.svg";